import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const LandngPage = () => {
  return (
    <>
      <Header />
	  
	  
	    
	  <section class="page-title">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-10">
        <h1>
   Contact Us



        </h1>
        
      </div>
    </div>
  </div>
  <div class="page-title-wave">
    <img src="./assets/images/page-bg.svg" alt="" />
  </div>
</section>

      <div className="page-content">
	  
	  <section class="">
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-md-12 ps-lg-10 order-lg-1">
        <div class="theme-title">
          <h6>Get In Touch</h6>
          <h2>Drop A Line!</h2>
        </div>
        <form id="contact-form" method="post" action="">
          <div class="messages"></div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <input id="form_name" type="text" name="name" class="form-control" placeholder="Name" required="required" data-error="Firstname is required." />
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input id="form_email" type="email" name="email" class="form-control" placeholder="Email Address" required="required" data-error="Valid email is required." />
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input id="form_phone" type="tel" name="phone" class="form-control" placeholder="Phone" required="required" data-error="Phone is required" />
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <textarea id="form_message" name="message" class="form-control" placeholder="Write Message" rows="4" required="required" data-error="Please,leave us a message."></textarea>
            <div class="help-block with-errors"></div>
          </div>
          <button class="themeht-btn primary-btn mt-4">
            <span>Send Message</span>
            <i class="bi bi-arrow-right"></i>
          </button>
        </form>
      </div>
      <div class="col-lg-5 col-md-12 mt-6 mt-lg-0">
        <div class="contact-box">
          <div class="theme-title">
            <h6>Contact Details</h6>
            
          </div>
          <ul class="contact-info list-unstyled">
            <li>
              <i class="flaticon flaticon-gps-1"></i>
              <span>Visit Our Location</span>
              <p>#10, 2nd Floor, Bldg no: 210 <br />
 Nuaija, Al Hilal, Doha - Qatar.</p>
            </li>
            <li>
              <i class="flaticon flaticon-email"></i>
              <span>Send Us Email</span>
              <a href="mailto:info@foxmedia.qa">info@foxmedia.qa</a>
            </li>
            <li>
              <i class="flaticon flaticon-mobile"></i>
              <span>Looking For Project</span>
              <a href="tel:++97470598308">+974 - 7059 8308</a>
            </li>
          </ul>
          <div class="social-icons mt-5">
            <ul class="list-inline">
              <li>
                <a href="#">
                  <i class="flaticon-facebook-app-symbol"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="flaticon-twitter-2"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="flaticon-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="flaticon-linkedin-1"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        
      </div>
      {/* <!--body content end-->  */}

      <Footer />

      {/* <!--back-to-top start--> */}
      <div className="scroll-top">
        <svg
          className="scroll-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!--back-to-top end--> */}
    </>
  );
};

export default LandngPage;
